/**
 * Elyus.ro — Optis ↔ Shopify Gallery Sync v2
 * Folosește alt text "optis:NumeTextură" pentru a face match între
 * swatches Optis și pozele din galeria Shopify.
 *
 * Instalare:
 * 1. Admin → Online Store → Themes → Craft → Edit code
 * 2. Assets → Add new asset → Create blank file → "optis-gallery-sync.js"
 * 3. Paste acest cod → Save
 * 4. Sections → main-product.liquid → caută </section> spre final
 * 5. Adaugă înainte: <script src="{{ 'optis-gallery-sync.js' | asset_url }}" defer></script>
 * 6. Save → testează pe pagina produsului
 */

(function () {
  'use strict';

  // Așteaptă ca Optis să fie încărcat
  function waitForOptis(callback, maxAttempts = 20) {
    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      const swatches = document.querySelectorAll('.po-option--swatch-wrapper input[type="radio"]');
      if (swatches.length > 0) {
        clearInterval(interval);
        callback(swatches);
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn('[Elyus] Optis swatches negăsite după ' + maxAttempts + ' încercări.');
      }
    }, 300);
  }

  // Extrage numele texturii din label-ul swatch-ului
  function getSwatchName(input) {
    const wrapper = input.closest('.po-option--swatch-wrapper');
    if (!wrapper) return null;
    const label = wrapper.querySelector('.po_option_value');
    return label ? label.textContent.trim() : null;
  }

  // Găsește slide-ul din galerie după alt text "optis:NumeTextură"
  function findSlideByAltText(swatchName) {
    if (!swatchName) return null;
    const targetAlt = 'optis:' + swatchName;

    const images = document.querySelectorAll('.product__media-item img');
    for (const img of images) {
      const alt = (img.getAttribute('alt') || '').trim();
      if (alt.toLowerCase() === targetAlt.toLowerCase()) {
        return img.closest('.product__media-item');
      }
    }
    return null;
  }

  // Activează slide-ul în galeria Craft
  function activateSlide(slide) {
    if (!slide) return;

    // Metoda 1 — API nativ Shopify media-gallery
    const gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      const mediaId = slide.getAttribute('data-media-id');
      if (mediaId) {
        gallery.setActiveMedia(mediaId, true);
        console.log('[Elyus] Activat via setActiveMedia:', mediaId);
        return;
      }
    }

    // Metoda 2 — click pe thumbnail
    const mediaId = slide.getAttribute('data-media-id');
    if (mediaId) {
      const thumb = document.querySelector(
        '.thumbnail-slider [data-media-id="' + mediaId + '"], ' +
        '.product__media-item--thumbnail [data-media-id="' + mediaId + '"]'
      );
      if (thumb) {
        thumb.click();
        console.log('[Elyus] Activat via click thumbnail:', mediaId);
        return;
      }
    }

    // Metoda 3 — scroll + is-active manual
    const allSlides = document.querySelectorAll('.product__media-item');
    allSlides.forEach(s => {
      s.classList.remove('is-active');
      s.setAttribute('aria-hidden', 'true');
    });
    slide.classList.add('is-active');
    slide.setAttribute('aria-hidden', 'false');
    slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    console.log('[Elyus] Activat via scroll manual.');
  }

  // Handler când se schimbă textura în Optis
  function onSwatchChange(event) {
    const input = event.target;
    if (!input || input.type !== 'radio') return;
    if (!input.closest('.po-option--swatch-wrapper')) return;

    const swatchName = getSwatchName(input);
    if (!swatchName) return;

    console.log('[Elyus] Textură selectată:', swatchName);

    const slide = findSlideByAltText(swatchName);
    if (slide) {
      console.log('[Elyus] Slide găsit pentru:', swatchName);
      activateSlide(slide);
    } else {
      console.warn('[Elyus] Slide negăsit pentru "' + swatchName + '". Verifică alt text: optis:' + swatchName);
    }
  }

  // Inițializare
  function init() {
    waitForOptis(function (swatches) {
      console.log('[Elyus] Optis găsit, ' + swatches.length + ' swatches. Sync activ.');

      // Ascultă pe document pentru a prinde și swatches dinamice
      document.addEventListener('change', onSwatchChange);

      // Activează prima textură selectată la încărcare
      setTimeout(function () {
        const checked = document.querySelector('.po-option--swatch-wrapper input[type="radio"]:checked');
        if (checked) {
          onSwatchChange({ target: checked });
        }
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();